import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as viewReducer from "containers/View/reducer";
import * as loginReducer from "containers/Login/reducer";

import TenantTile from "components/Tiles/TenantTile";
import SubView from "components/View/SubView";
import * as adminReducer from "containers/Admin/reducer";

import { isEnabled } from "utils/featureFlags";

class TenantViewContainer extends React.PureComponent {
  handleTenantClick() {}

  renderFirstTile() {
    const { handleRegisterTenant, hideFirstTile } = this.props;

    if (hideFirstTile || !isEnabled("add-workspace")) {
      return <div style={{ height: "170px" }}></div>;
    }

    return <TenantTile isCreate handleRegisterTenant={(name) => handleRegisterTenant(name)} />;
  }

  render() {
    const {
      isTile,
      isLoading,
      selectedTenant,
      selectTenant,
      handleInvite,
      handleChangeSharing,
      data,
      isWorkspaceSharing,
      subViewType
    } = this.props;

    return (
      <SubView
        {...this.props}
        label="Tenants"
        firstTile={this.renderFirstTile()}
        tileHeight={165}
        isInfinite={true}
        childrenLength={data.length}
        renderTile={(columnIndex, style) => {
          if (data && data.length > columnIndex) {
            const isSelected = selectedTenant && selectedTenant.id === data[columnIndex].id;
            return (
              <div style={style} key={data[columnIndex].id}>
                <TenantTile
                  handleChangeSharing={handleChangeSharing}
                  id={data[columnIndex].id}
                  tenant={data[columnIndex]}
                  isSelected={isSelected}
                  onClick={() => !isSelected && selectTenant(data[columnIndex])}
                  handleInvite={handleInvite}
                  isWorkspaceSharing={isWorkspaceSharing}
                />
              </div>
            );
          }
        }}
        isTile
        type={subViewType}
      >
        {data &&
          data.map((tenant, i) => {
            const isSelected = selectedTenant && selectedTenant.id === tenant.id;
            return (
              <TenantTile
                id={tenant.id}
                tenant={tenant}
                key={tenant.id}
                isSelected={isSelected}
                onClick={() => !isSelected && selectTenant(tenant)}
                handleInvite={handleInvite}
                isWorkspaceSharing={isWorkspaceSharing}
              />
            );
          })}
      </SubView>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  selectTenant: (tenant) => dispatch(loginReducer.selectTenant(tenant, true)),
  handleRegisterTenant: (name) => dispatch(loginReducer.handleRegisterTenant(name)),
  handleChangeSharing: (tenantId, mode) => dispatch(loginReducer.handleChangeSharing(tenantId, mode)),

  handleInvite: (tenantID, email) => dispatch(adminReducer.sendInviteFromTenant(tenantID, email))
});

const mapStateToProps = (state, ownProps) => ({
  type: viewReducer.getSettingsType(state),
  isLoading: loginReducer.getIsLoading(state),

  isWorkspaceSharing: loginReducer.getIsWorkspaceSharing(),

  selectedTenant: loginReducer.getSelectedTenant(state),
  data: viewReducer.getTenants(state)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(TenantViewContainer);
